export default __webpack_public_path__ + "static/media/premium-clock-icon-sense.b13881713504992e081e46f4f0be0793.svg";